import {
    ApartmentOutlined, DeploymentUnitOutlined,
    FieldTimeOutlined,
    TableOutlined,
    UserOutlined,
    SettingOutlined,
    EyeOutlined,
    HeartOutlined,
    DribbbleOutlined,
    DesktopOutlined,
    PlayCircleOutlined,
    FileProtectOutlined,
    GlobalOutlined,
    VideoCameraOutlined,
    FolderOpenFilled,HomeOutlined,
    ClockCircleOutlined,
    PayCircleOutlined,
    ContactsOutlined
}from "@ant-design/icons";
//#region General
import { GetTranslation } from './general';
//#endregion
//#region Management
import UserProfList from "../../Views/Management/UserProfList"
//#endregion Management
//#region Dashboard
import Dashboard from "../../Views/Dashboard";
//#region Task Management
// import TaskManagement from "../../Views/TaskManagement/TaskManagement"
import TaskManagement from "../../Views/TaskManagement/TaskManagement";

import TaskManagement2 from "../../Views/TaskManagement/TaskManagement2";
//#endregion Task Management
//#region Claim Management
// import ClaimManagement from "../../Views/ClaimManagement/ClaimManagement";
import ClaimManagement from "../../Views/ClaimManagement/ClaimManagement";
//#endregion
//#region Branch Management
import BranchManagement from '../../Views/Management/BranchManagement';
//#endregion
//#region Attendance
import Attendance from '../../Views/Attendance/attendance';
import AttendanceManagement from '../../Views/Attendance/management';
//#endregion
//#region Shift
import ShiftManagement from "../../Views/Management/ShiftManagement";
//#endregion
//#region Department
import DepartmentManagement from "../../Views/Management/DepartmentManagement";
//#endregion
//#region Department
import HolidayManagement from "../../Views/Management/HolidayManagement";
//#endregion
//#region Payee 
import PayeeManagement from "../../Views/Management/PayeeManagement";
//#endregion
//#region Payment Acct 
import PaymentAcctManagement from "../../Views/Management/PaymentAcctManagement";
//#endregion
//#region Payment Item 
import PaymentItemManagement from "../../Views/Management/PaymentItemManagement";
//#endregion
//#region REPORTING
import AttedanceReporting from '../../Views/Attendance/report';
import TaskReporting from '../../Views/Report/TaskReport';
import FookTest from '../../Views/Test/test/fooktest'
import Reminder from '../../Views/Management/Reminder'
import ContactList from "../../Views/Management/ContactList";
//#endregion
//#region Paymeny
import Payment from "../../Views/Payment/Payment";
import PaymentListing from "../../Views/Payment/PaymentListing";
import { TaskRounded } from "@mui/icons-material";
//#endregion
//#endregion MODULES


const userlang  = navigator.language || navigator.userLanguage;
const
    //#region Category title
    management          = "Management",
    taskmanagement      = GetTranslation(userlang, "Task Management"),

    taskmanagement2     = GetTranslation(userlang, "Task Management2"),
    claimmanagement     = GetTranslation(userlang, "Claim Management"),            // 20210727 anchor cold
    // branchmanagement    = "Branch Management",
    attendance          = GetTranslation(userlang, "Take Attendance"),
    report              = "Reporting",
    test                = "Test",
    dashboard           = "Dashboard",
    reminder            = "Reminder",
    contactlist         = "ContactList",
    paymentmanagement   = GetTranslation(userlang, "Payment"),
    //#endregion Category title
    key_mgmt        = 0,
    key_taskmgmt    = 10,
    key_claimmgmt   = 11,
    key_attendance  = 12,
    key_reporting   = 13,
    key_dashboard   = 14,
    key_reminder    = 15,
    key_contact     = 16,
    key_payment     = 17,
    key_outsider    = 98,
    key_test        = 99,
    //#region Permission Constants
    perm_mgmt_userprofile = "101",

    perm_task_mgmt          = "2001",
    perm_claim_mgmt         = "2002",            // 20210727 anchor cold
    perm_branch_mgmt        = "2003",           // 20210811 anchor cold
    perm_attendance         = "2004",
    perm_attendance_mgmt    = "2005",           //20210812 anchor cold
    perm_shift_mgmt         = "2006",
    perm_dashboard          = "2010",
    perm_department_mgmt    = "2011",
    perm_reminder_mgmt      = "2012",
    perm_contactlist_mgmt   = "2013",

    perm_payment            = "2014",           //20221219 anchor jupiter
    perm_payment_listing    = "2015",           //20221219 anchor jupiter
    perm_payee_mgmt         = "2016",           //20221219 anchor jupiter
    perm_paymentacct_mgmt   = "2017",           //20221219 anchor jupiter

    perm_paymentitem_mgmt   = "2018",           //20221219 anchor jupiter

    perm_holiday_mgmt       = "2019",           //20221219 anchor jupiter
    // Report
    perm_task_report        = "2007",
    perm_claim_report       = "2008",
    perm_attendance_report  = "2009"


//#endregion Permission Constants

//#region PageAccessControls
export const pages = [
    //#region management start 1
    {
        key: perm_mgmt_userprofile,
        title: 'User',
        path: "/userprofile",
        exact: true,
        parent: management,
        component: <UserProfList title="User" />,
        icon: <UserOutlined />
    },
    //#endregion management
    //#region Dashboard
    {
        key: perm_dashboard,
        title: GetTranslation(userlang,'Dashboard'),
        path: "/Dashboard",
        exact: true,
       // parent: dashboard,
        component: <TaskManagement title={GetTranslation(userlang, "TaskManagement")} />,
        icon: <TableOutlined />
    },
    //#endregion Dashboard
    //#region TaskManagement
    {
        key: perm_task_mgmt,
        title: GetTranslation(userlang,'Task Management'),
        path: "/TaskManagement",
        exact: true,
        parent: taskmanagement,
        component: <TaskManagement title={GetTranslation(userlang, "Task Management")} />,
        icon: <TableOutlined />
    },
    //#endregion TaskManagement
     //#region TaskManagement2
     {
        key: perm_task_mgmt,
        title: GetTranslation(userlang,'Task Management'),
        path: "/TaskManagement2",
        exact: true,
        parent: taskmanagement2,
        component: <TaskManagement2 title={GetTranslation(userlang, "Task Management")} />,
        icon: <TableOutlined />
    },
    //#endregion TaskManagement2
      //#region ClaimManagement
    //20210727 Jupiter ADD FOR reminder
    {
        key         : perm_reminder_mgmt,
        title       : 'Reminder',
        path        : "/Reminder",
        exact       : true,
        parent      : reminder,
        component   : <Reminder title="Reminder" />,
        icon        : <ClockCircleOutlined />
    },
    //#endregion
    //   //20221219 Jupiter ADD FOR payment
    //   {
    //     key         : perm_payment,
    //     title       : 'Dashboard',
    //     path        : "/Payment",
    //     exact       : true,
    //     parent      : paymentmanagement,
    //     component   : <Payment title="Payment" />,
    //     icon        : <PayCircleOutlined />
    // },
     //20221219 Jupiter ADD FOR payment
     {
        key         : perm_payment_listing,
        title       : 'Payment',
        path        : "/PaymentListing",
        exact       : true,
        parent      : paymentmanagement,
        component   : <PaymentListing title="Payment Listing" />,
        icon        : <PayCircleOutlined />
    },
    //#endregion
     //20210727 Jupiter ADD FOR contact
     {
        key         : perm_contactlist_mgmt,
        title       : 'Contact List',
        path        : "/Contactlist",
        exact       : true,
        parent      : reminder,
        component   : <ContactList title="Contact List" />,
        icon        : <ClockCircleOutlined />
    },
    //#endregion
    //#region ClaimManagement
    //20210727 ANCHOR COLD ADD FOR CLAIM
    {
        key         : perm_claim_mgmt,
        title       : GetTranslation(userlang, "Claim Management"),
        path        : "/ClaimManagement",
        exact       : true,
        parent      : claimmanagement,
        component   : <ClaimManagement title={GetTranslation(userlang, "Claim Management")} />,
        icon        : <TableOutlined />
    },
    //#endregion
    //#region BranchManagement
    //20210727 ANCHOR COLD ADD FOR BRANCH
    {
        key         : perm_branch_mgmt,
        title       : 'Branch',
        path        : "/BranchManagement",
        exact       : true,
        parent      : management,
        component   : <BranchManagement title="Branch" />,
        icon        : <TableOutlined />
    },
    //#endregion

    //20230115 ANCHOR JUPITER ADD FOR BRANCH
    {
        key         : perm_holiday_mgmt,
        title       : 'Holiday',
        path        : "/HolidayManagement",
        exact       : true,
        parent      : management,
        component   : <HolidayManagement title="Holiday" />,
        icon        : <TableOutlined />
    },
    //#endregion
    //#region BranchManagement
    //#region Attendance
    //20210727 ANCHOR COLD ADD FOR ATTENDANCE
    {
        key         : perm_attendance,
        title       : GetTranslation(userlang, "Take Attendance"),
        path        : "/Attendance",
        exact       : true,
        parent      : attendance,
        component   : <Attendance title={GetTranslation(userlang, "Take Attendance")} />,
        icon        : <TableOutlined />
    },
    {
        key         : perm_attendance_mgmt,
        title       : "Attendance",
        path        : "/AttendanceManagement",
        exact       : true,
        parent      : management,
        component   : <AttendanceManagement title="Attendance Management" />,
        icon        : <TableOutlined />
    },
    {
        key         : perm_shift_mgmt,
        title       : "Shift",
        path        : "/ShiftManagement",
        exact       : true,
        parent      : management,
        component   : <ShiftManagement title="Shift Management" />,
        icon        : <TableOutlined />
    },
    {
        key         : perm_department_mgmt,
        title       : "Department",
        path        : "/DepartmentManagement",
        exact       : true,
        parent      : management,
        component   : <DepartmentManagement title="Department Management" />,
        icon        : <TableOutlined />
    },
    //20230313 ANCHOR Jupiter ADD FOR Payee
    {
        key         : perm_payee_mgmt,
        title       : 'Payee',
        path        : "/PayeeManagement",
        exact       : true,
        parent      : management,
        component   : <PayeeManagement title="Payee" />,
        icon        : <PayCircleOutlined />
    },
    //#endregion
    //20230313 ANCHOR Jupiter ADD FOR Payment Acct
    {
        key         : perm_paymentacct_mgmt,
        title       : 'Payment Acct',
        path        : "/PaymentAcct",
        exact       : true,
        parent      : management,
        component   : <PaymentAcctManagement title="Payment Account" />,
        icon        : <PayCircleOutlined />
    },
    //#endregion
    //20230313 ANCHOR Jupiter ADD FOR Payment Acct
    {
        key         : perm_paymentitem_mgmt,
        title       : 'Payment Item',
        path        : "/PaymentItem",
        exact       : true,
        parent      : management,
        component   : <PaymentItemManagement title="Payment Item" />,
        icon        : <PayCircleOutlined />
    },
    //#endregion
    {
        key         : perm_attendance_report,
        title       : "Attendance",
        path        : "/AttendanceReport",
        exact       : true,
        parent      : report,
        component   : <AttedanceReporting title="Attendance Reporting" />,
        icon        : <TableOutlined />
    },
    {
        key         : perm_claim_report,
        title       : "Claim",
        path        : "/ClaimReport",
        exact       : true,
        parent      : report,
        icon        : <TableOutlined />
    },
    {
        key         : perm_task_report,
        title       : "Task",
        path        : "/TaskReport",
        exact       : true,
        parent      : report,
        component   : <TaskReporting title="Task Reporting" />,
        icon        : <TableOutlined />
    }
    //#endregion
]

export const testpages = [
    {
        key         : key_test,
        title       : test,
        path        : "/Test",
        exact       : true,
        component   : <FookTest title="1111" />,
        icon        : <TableOutlined />
    }
]

export const dashboardpages = [
    {
        key         : key_dashboard,
        title       : dashboard,
        path        : "/Dashboard",
        exact       : true,
        component: <TaskManagement title={GetTranslation(userlang, "TaskManagement")} />,
        icon        : <HomeOutlined />
    }
]
export const remidnerdpages = [
    {
        key         : key_reminder,
        title       : reminder,
        path        : "/Reminder",
        exact       : true,
        component: <Reminder title={GetTranslation(userlang, "Reminder")} />,
        icon        : <ClockCircleOutlined />
    }
]
export const contactlistpages = [
    {
        key         : key_contact,
        title       : contactlist,
        path        : "/Contactlist",
        exact       : true,
        component: <ContactList title={GetTranslation(userlang, "Contact List")} />,
        icon        : <ContactsOutlined />
    }
]
// export const paymentpages = [
//     {
//         key         : key_payment,
//         title       : "Payment",
//         path        : "/Payment",
//         exact       : true,
//         component: <Payment title={GetTranslation(userlang, "Payment")} />,
//         icon        : <PayCircleOutlined />
//     }
//]
export const taskpages = [
    {
        key         : key_outsider,
        title       : "Task",
        path        : "/TaskManagement",
        exact       : true,
        component: <TaskManagement title={GetTranslation(userlang, "TaskManagement")} />,
        icon        : <TableOutlined />
    }
]
export const paymentpages = [
    {
        key: key_payment,
        //childs: [perm_payment, perm_payment_listing],
        title: paymentmanagement,
        path : "/Paymentlisting",
        exact: true,
        omponent: <PaymentListing title={GetTranslation(userlang, "PaymentListing")} />,
        icon: <PayCircleOutlined />
    }
]
export const categories = [
    {
        key: key_mgmt,
        childs: [perm_mgmt_userprofile,perm_holiday_mgmt, perm_branch_mgmt, perm_attendance_mgmt,perm_department_mgmt,perm_payee_mgmt,perm_paymentacct_mgmt,perm_paymentitem_mgmt],
        title: management,
        exact: true,
        icon: <DeploymentUnitOutlined />
    },
    {
        key: key_taskmgmt,
        childs: [perm_task_mgmt],
        title: taskmanagement,
        exact: true,
        icon: <TableOutlined />
    },
    //20210727 ANCHOR COLD ADD FOR CLAIM
    {
        key     : key_claimmgmt,
        childs  : [perm_claim_mgmt],
        title   : claimmanagement,
        exact   : true,
        icon    : <TableOutlined />
    },
    //20210811 ANCHOR COLD ADD FOR ATTENDANCE
    {
        key     : key_attendance,
        childs  : [perm_attendance],
        title   : attendance,
        exact   : true,
        icon    : <TableOutlined />
    },
    //20210906 ANCHOR REPORT ADD FOR REPORTING
    {
        key     : key_reporting,
        childs  : [perm_attendance_report, perm_claim_report, perm_task_report],
        title   : report,
        exact   : true,
        icon    : <TableOutlined />
    }
]

//#endregion PageAccessControls
//#region User Related

export const UserType = {
    0: 'APIUSER',
    1: 'SUBUSER',
    2: 'STREAMER',
    3: 'BRANDUSER',
    4: 'BROADCASTER'
}



export const CompanyId = {
    "glive" : "glive",
    "startv": "startv"
}

export const BroadPerm = {
    4: 'BROADCASTER'
}

//#endregion User Related
// export const Permission = {
//     profile: {},
//     channelSetting: {},
//     viewer: {},
//     monitor: {},
//     online: {},
// }

export const tableProps = {
    filterConfirm: { closeDropdown: false },
    bordered: true,
    size: "small",
    pagination: { position: ["topRight", "bottomRight"], pageSizeOptions: [50, 100], defaultPageSize: 50 },
    style: { padding: "15px" }

}

//#region ENTITY_STATUSES


export const USR_STATUS = [{
    key: 1,
    title: "Active",
    color: "green"
}, {
    key: 4,
    title: "Suspended",
    color: "orange"
},
{
    key: 0,
    title: "Disable",
    color: "red"
}
]

export const UserStatus = {
    1: "active",
    8: 'trial',
    9: 'suspended',
    0: 'disable'
}

//#endregion ENTITY_STATUSES


export const BRANCH_STATUS = [{
    key: 1,
    title: "Active",
    color: "green"
}, {
    key: 4,
    title: "Suspended",
    color: "orange"
}
]

export const BranchStatus = {
    1: "active",
    0: 'disable'
}

//#endregion ENTITY_STATUSES

